/* global _monthNames, _monthShortNames */
const dust = require('dustjs-linkedin');
// enable debug for dust
if (__DEV__) {
	dust.isDebug = true;
	dust.debugLevel = 'INFO'; // 'DEBUG' | 'INFO' | 'WARN' | 'ERROR'
}
/**
 * Transform ISO 8601(2014-02-23T00:00:00) date in gg MMMM YYYY
 * @param  {Object} chunk   [description]
 * @param  {Object} context [description]
 * @param  {Object} bodies  [description]
 * @param  {Object} params  An object that contains the values
 * @return {Object}         The chunk
 */
dust.helpers.formatDate = function formatDate(chunk: Object, context: Object, bodies: Object, params: Object): Object {
	// the date is 2014-02-23T00:00:00 ISO 8601
	// ie doesn't support this format
	if (params.value !== undefined && params.value !== null) {
		const fixedDate = params.value.split('T')[0].replace(/-/g, '/');
		const timestamp = new Date(fixedDate);
		const monthIndex = timestamp.getMonth();
		const month = _monthNames[monthIndex];
		const date = timestamp.getDate();
		const year = timestamp.getFullYear();
		return chunk.write(`${date} ${month} ${year}`);
	}
	return undefined;
};

/**
 * Transform js timestamp /Date(1451520000000)/ (.NET JavaScriptSerializer) in gg/mm/YYYY
 * @param  {Object} chunk   [description]
 * @param  {Object} context [description]
 * @param  {Object} bodies  [description]
 * @param  {Object} params  An object that contains the values
 * @return {Object}         The chunk
 */
dust.helpers.formatDateToIt = function formatDateToIt(chunk: Object, context: Object, bodies: Object, params: Object): Object {
	const value = params.value;
	if (value !== undefined && value !== null) {
		const timestamp = new Date(+value.replace('/Date(', '').replace(')/', '')); // or parseInt(value.substr(6))
		const day = timestamp.getDate();
		const month = timestamp.getMonth() + 1; // month is zero based
		const year = timestamp.getFullYear();
		return chunk.write(`${day}/${month}/${year}`);
	}
	return undefined;
};
/**
 * Transform ISO 8601(2014-02-23T00:00:00) date in gg
 * @param  {Object} chunk   [description]
 * @param  {Object} context [description]
 * @param  {Object} bodies  [description]
 * @param  {Object} params  An object that contains the values
 * @return {Object}         The chunk
 */
dust.helpers.getDay = function getDay(chunk: Object, context: Object, bodies: Object, params: Object): Object {
	if (params.value !== undefined && params.value !== null) {
		// the date is 2014-02-23T00:00:00 ISO 8601
		// ie doesn't support this format
		const fixedDate = params.value.split('T')[0].replace(/-/g, '/');
		const timestamp = new Date(fixedDate);
		const day = timestamp.getDate();
		return chunk.write(day);
	}
	return undefined;
};

/**
 * Transform ISO 8601(2014-02-23T00:00:00) date in mm
 * @param  {Object} chunk   [description]
 * @param  {Object} context [description]
 * @param  {Object} bodies  [description]
 * @param  {Object} params  An object that contains the values
 * @return {Object}         The chunk
 */
dust.helpers.getShortMonth = function getShortMonth(chunk: Object, context: Object, bodies: Object, params: Object): Object {
	if (params.value !== undefined && params.value !== null) {
		// the date is 2014-02-23T00:00:00 ISO 8601
		// ie doesn't support this format
		const fixedDate = params.value.split('T')[0].replace(/-/g, '/');
		const timestamp = new Date(fixedDate);
		const monthIndex = timestamp.getMonth();
		const month = _monthShortNames[monthIndex];
		return chunk.write(month);
	}
	return undefined;
};



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/dustjs-custom-helpers.js
 **/